import React, { useState } from 'react';
import { Box, FormControl, FormHelperText, MenuItem, Select, Stack, Typography } from '@mui/material';

import globalStyles from '../utilities/styles';
import Header from './web/header';
import SubHeader from './web/subHeader';
import messages from '../utilities/messages';
import Footer from './web/footer';

function SelectCompany({ selectedCompany = '', headerTitle, availableCompanies, handleCompanyClick }) {
  const [companyName, setCompanyName] = useState(selectedCompany)
  const [isValidForm, setValidation] = useState(true)

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
        <Header title={headerTitle}
        />
        <SubHeader title={messages.company.title} />
        <FormControl size='small'
          sx={{ p: '20px 0px', alignItems: 'center' }}
          display='flex'
          flexDirection={'column'}
          error={!isValidForm && companyName === ''}
        >
          <Stack sx={{ width: globalStyles.fieldWidth }}>
            <Typography display={'flex'} variant="caption" color="textSecondary" fontWeight='bold'>
              {messages.company.title}<sup style={{ color: 'red' }}>*</sup>
            </Typography>
            <Select
              sx={{
                mt: '5px'
              }}
              margin="dense"
              labelId="select-company"
              id="select-company"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
            >
              {availableCompanies.map((company, index) => (
                <MenuItem key={index} value={company}>{company}</MenuItem>
              ))}
            </Select>
            {
              !isValidForm && companyName === '' &&
              <FormHelperText>Field is required.</FormHelperText>

            }
          </Stack>
        </FormControl>
        <Footer
          submitTitle='Confirm'
          handleSubmit={() => {
            companyName === '' ? setValidation(false)
              : handleCompanyClick(companyName)
          }}
        />
      </Box>
    </>
  );

  //   <div>
  //     <h1>Login</h1>
  //     {error && <div style={{ color: 'red' }}>{error}</div>} {/* Display error message if any */}
  //     <input
  //       type="text"
  //       placeholder="Username"
  //       value={username}
  //       onChange={(e) => setUsername(e.target.value)}
  //     />
  //     <input
  //       type="password"
  //       placeholder="Password"
  //       value={password}
  //       onChange={(e) => setPassword(e.target.value)}
  //     />
  //     <button onClick={handleLogin}>Login</button>
  //   </div>
  // );
}

export default SelectCompany;
